import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function PlatformFinalCta({ lang }: { lang: string }): JSX.Element {
  const { t } = useTranslation("common");

  // Always-dark brand block in both themes: the ground and every colour on
  // it are the design's literals, not theme tokens, so ``.dark`` has
  // nothing to invert.
  return (
    <section className="final" data-testid="platform-final-cta">
      <div aria-hidden="true" className="final-grid grid-bg-dense" />
      <div className="final-inner">
        <h2>
          {t("platformLanding.finalCta.headingLine1")}
          <br />
          <span className="gray">
            {t("platformLanding.finalCta.headingLine2")}
          </span>
        </h2>
        <p>{t("platformLanding.finalCta.body")}</p>
        <div className="final-cta">
          <Link to={`/${lang}/sign-up-shop`} className="btn-light">
            {t("platformLanding.finalCta.primary")}
            <span aria-hidden="true">→</span>
          </Link>
          <Link to={`/${lang}/contact`} className="btn-ghost">
            {t("platformLanding.finalCta.secondary")}
          </Link>
        </div>
        <p className="final-meta">{t("platformLanding.finalCta.meta")}</p>
      </div>
    </section>
  );
}
